/* istanbul ignore file */
import React from 'react';
import SinglePurchaseOrderBreadcrumbs from 'domain/finance/purchaseOrder/shared/SinglePurchaseOrderBreadcrumbs';
import { UpdateBreadcrumbItem } from 'framework/ui/BreadCrumbs';

const UpdatePurchaseOrderBreadcrumbs = () => {
  return (
    <SinglePurchaseOrderBreadcrumbs>
      <UpdateBreadcrumbItem />
    </SinglePurchaseOrderBreadcrumbs>
  );
};

export default UpdatePurchaseOrderBreadcrumbs;
